import { Component } from '@angular/core';

@Component({
  selector: 'app-web-development',
  standalone: true,
  imports: [],
  templateUrl: './web-development.component.html',
  styleUrl: './web-development.component.scss'
})
export class WebDevelopmentComponent {

}
